<template>
    <b-row class="mb-5">
        <b-col md="12">
          <div class="pt-2 pb-2 float-right">
            <a variant="light" style="margin-top:-100px!important; margin-right:10px!important;" class="btn-back btn-custom"></a>
            <!-- <b-button variant="info" style="margin-top:-88px!important;" class="mr-1 btn-download btn-custom" @click="doExportToExcel"><font-awesome-icon icon="download" style="font-size:15px!important;" /></b-button> -->
            <!-- <b-button variant="primary" style="margin-top:-88px!important;" class="btn-back btn-custom" @click="showModal"><font-awesome-icon icon="plus"/></b-button> -->
          </div>
          <paginated-table ref="dataTable" :can-edit="false" :can-edit-modal="true" :can-delete="false" :can-approve="false" :can-reject="false" :can-show="true" :can-show-route-path="'#/vehicle/service-detail'" :can-paid="false" v-on:editData="doEdit" :data-url="apiUrl.vehicleBill" :data-key="dataKey" :data-columns="columns" :modal-view="false">
          </paginated-table>
        </b-col>
      <!-- <add-road-tax-modal ref="addRoadTax" v-on:getServiceBill="getServiceBill"></add-road-tax-modal> -->
      <edit-service-modal ref="editService" v-on:getServiceBill="getServiceBill"></edit-service-modal>
    </b-row>
</template>
<script>
  import PaginatedTable from '@/components/PaginatedTable'
  import EditServiceModal from './EditServiceModal'
  // import EditRoadTaxModal from './EditRoadTaxModal'
  export default {
    props: {
      vehicleUuid: {
        type: String,
        required: false
      }
    },
    components: {
      PaginatedTable,
      EditServiceModal
    },
    data: function() {
      var currentDate = new Date();
      var twoDigitFirstMonth= '01';  
      var twoDigitFirstDate= '01';
      var createdDateTo = currentDate.getFullYear() + "-" + twoDigitFirstMonth + "-" + twoDigitFirstDate;
      
      var currentDate = new Date();
      var twoDigitLastMonth= '12';  
      var twoDigitLastDate= '31';
      var createdDateBy = currentDate.getFullYear() + "-" + twoDigitLastMonth + "-" + twoDigitLastDate;

      return {
        dataKey: "vehicleBillInfo",
        type: "Service",
        isLoading: false,
        apiUrl: {
          vehicleRequest: window.AppConfig.apiUrl + 'vehicle-request',
          vehicleBill: window.AppConfig.apiUrl + 'vehicle-bill-info?vehicle_uuid=' + this.vehicleUuid + '&type=Service&start_due_date=' + createdDateTo + '&end_due_date=' + createdDateBy,
          exportService: window.AppConfig.apiUrl + 'export-vehicle-bill-general'
        },
        model: {
          uuid: null,
          billNumber: null,
          amount: null,
          photoBill: null,
          note: null
        },
        serviceDate: null,
        modelValidations: {
          billNumber: {
            required: true
          },
          serviceDate: {
            required: true
          },
          amount: {
            required: true
          },
          order: {
            required: true
          }
        },
        columns: [
          // {
          //   label: 'Bill Number',
          //   key: 'billNumber',
          //   sortable: false
          // },
          {
            key: 'issuedBy',
            label: 'Issued By',
            sortable: false
          },
          {
            key: 'createdAtType',
            label: 'Issued Date',
            sortable: false
          },
          {
            key: 'typeDate',
            label: 'Service Date',
            sortable: false
          },
          {
            key: 'amounts',
            label: 'Amount',
            sortable: false
          },
          {
            key: 'paidDateVehicle',
            label: 'Paid Date',
            sortable: false
          },
          {
            key: 'notes',
            label: 'Note',
            sortable: false
          },
          {
            key: 'statusType',
            label: 'Status',
            sortable: false
          },
          {
            key: 'actions',
            label: '',
            sortable: false
          }
        ],
        vehicleRequestList: []
      }
    },
    mounted() {
      this.getServiceBill()
    },
    methods: {
        getServiceBill () {
          this.isLoading = true
          this.$refs.dataTable.getDataTable()
        },
        getDateTime (value) {
          if (value !== null) {
            return this.$moment(value).format('YYYY-MM-DD HH:mm A')
          } else {
            return '-'
          }
        },
        doExportToExcel () {
          let url = this.apiUrl.exportService + '?token=' + this.$store.getters['account/tokens'].access_token + '&type=Service&vehicle_uuid=' + this.vehicleUuid
          
          window.open(url)
        },
        // doModalAddRoadTax () {
        //   this.$refs.addRoadTax.showModal()
        // },
        doEdit (row) {
          this.$refs.editService.showModal(row)
        },
        doShowModal (row) {
          this.$refs.editRoadTax.showModal(row)
        },
    }
  }
</script>